<template>
  <el-aside class="pagesider" :class="{ 'is-collapsed': isMenuCollapse }">
    <el-button type="text" class="toggle-btn" @click="toggleMenu">
      <svgicon name="menu"></svgicon>
    </el-button>
    <a class="logo" href="#">
      <el-image :src="$store.state.logoUrl" fit="contain"></el-image>
    </a>
    <div class="pagesider-c">
      <el-menu
        :default-active="$route.path"
        unique-opened
        @open="handleOpen"
        @close="handleClose"
        :collapse="isMenuCollapse"
      >
        <h4 @click="openIndex" style="cursor: pointer" v-if="!getSpecialUser()">
          <!-- <i class="el-icon-menu"></i> -->
          <i><svgicon name="diamond" /></i>
          <!-- BIVALE电梯设施管理系统 -->
          {{ $l("日立电梯全日+客户服务") }}
        </h4>
        <el-menu-item
          index="openIndex"
          v-if="isMenuCollapse"
          @click="openIndex"
        >
          <i class="el-icon-menu" style="width: 18px; height: 18px"></i>
          <span slot="title">
            <!-- BIVALE电梯设施管理系统 -->
            {{ $l("日立电梯全日+客户服务") }}
          </span>
        </el-menu-item>
        <template v-for="item in getRoutes($router.options.routes)">
          <el-submenu v-if="getLeaf(item)" :index="item.path" :key="item.path">
            <template slot="title">
              <svgicon
                :name="item.icon"
                :original="true"
                :class="'svg-' + item.icon"
              ></svgicon>
              <span slot="title" :title="$l(item.meta.title)">{{
                $l(item.meta.title)
              }}</span>
            </template>
            <el-menu-item
              v-for="child in getItem(item)"
              :key="child.path"
              :index="item.path + '/' + child.path"
              @click="selectItem(item, child)"
            >
              <span slot="title" :title="$l(child.meta.title)">{{
                $l(child.meta.title)
              }}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item
            v-else
            :index="item.path"
            @click="selectItem(item, '')"
            :key="item.name"
          >
            <svgicon
              :name="item.icon"
              :original="true"
              :class="'svg-' + item.icon"
            ></svgicon>
            <span slot="title" :title="$l(item.meta.title)">{{
              $l(item.meta.title)
            }}</span>
          </el-menu-item>
        </template>
        <h4 @click="openOMS" style="cursor: pointer">
          <!-- <i class="el-icon-s-grid"></i> -->
          <i><svgicon name="page" /></i>
          {{ $l("BIVALE") }}
        </h4>

        <el-menu-item index="openOMS" v-if="isMenuCollapse" @click="openOMS">
          <i class="el-icon-s-grid" style="width: 18px; height: 13px"></i>
          <span slot="title"> {{ $l("BIVALE") }}</span>
        </el-menu-item>
        <!-- <el-menu-item index="download"> -->
        <!-- <svgicon
              name="download"
              :original="isSelectedMenu.name != item.name"
              :class="'svg-' + item.icon"
          ></svgicon>-->
        <!-- <svgicon name="download" :original="true" class="svg-download"></svgicon>
          <span slot="title">下载管理</span>
        </el-menu-item>
        <el-menu-item index="help">
          <svgicon name="doc" :original="true" class="svg-doc"></svgicon>
          <span slot="title">帮助文档</span>
        </el-menu-item> -->
        <!-- <el-menu-item index="logout" v-if="isMenuCollapse" @click="logout">
          <svgicon name="run" :original="true" class="svg-run"></svgicon>
          <span slot="title">Logout</span>
        </el-menu-item> -->
        <el-menu-item
          index="newhref"
          v-if="isMenuCollapse && isShowNewHref"
          @click="newhref"
        >
          <svgicon name="run" :original="true" class="svg-run"></svgicon>
          <span slot="title">{{ $l("智能管理平台") }}</span>
        </el-menu-item>
      </el-menu>
      <!-- <el-row type="flex" justify="center">
        <el-button type="primary" round @click="logout" v-show="!isMenuCollapse"
          >Logout</el-button
        >
      </el-row> -->
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          round
          @click="newhref"
          v-show="!isMenuCollapse && isShowNewHref"
          >{{ $l("智能管理平台") }}</el-button
        >
      </el-row>
    </div>
  </el-aside>
</template>

<script>
import global from "@/mixins/global.js";
export default {
  name: "pagesider",
  mixins: [global],
  props: {},
  data() {
    return {
      // siderWidth: "300px",
      // isMenuCollapse: false,
      siderWidth: "",
      isMenuCollapse: "",
      isSelectedMenu: {
        name: "",
        index: "",
      },
      isShowNewHref: false,
    };
  },
  created() {
    this.$store.state.user = JSON.parse(localStorage.getItem("user"));
    this.user = this.$store.state.user;
    this.siderWidth = this.siderConfig.siderWidth;
    this.isMenuCollapse = this.siderConfig.isMenuCollapse;
    if (this.$store.state.user.username == "saler") {
      this.isShowNewHref = false;
    }
  },
  computed: {
    siderConfig() {
      return this.$store.state.siderConfig;
    }
  },
  watch: {
    $route() {
      // this.getBreadcrumb();
    },
    "siderConfig.isMenuCollapse": function (val, oldVal) {
      this.isMenuCollapse = val;
    },
    // isMenuCollapse(val) {
    //   return val;
    // }
  },
  methods: {
    getSpecialUser(){
       const user = this.getSpecialUserInfo();
       if(user) {
          this.$store.state.logoUrl = user.logoUrl;
       }
       return user;
    },
    getRoutes(routes) {
      return routes.filter(
        (item) =>
          !item.hidden &&
          this.getPermission(item.name) &&
          this.$store.state.isShowMenu
      );
    },
    getItem(item) {
      const children =
        item.name == "largeScreen" ? item.children[0].children : item.children;
      return children.filter((t) => !t.hidden && this.getPermission(t.name));
    },
    handleOpen() {},
    handleClose() {},
    //选择菜单栏目
    menuHoverCancel() {},
    menuHover(index) {},
    selectItem(item, child) {
      let itemPath = item.path;
      let childPath = child ? child.path : "";
      let path = itemPath + "/" + childPath;
      this.isSelectedMenu.name = item.name;
      if (item.name == "largeScreen") {
        path = itemPath + "/screenPage/" + childPath;
      }
      if (item.leaf) {
        path = itemPath;
      }
      if (child) {
        this.logRecord(child.meta.title);
      } else {
        this.logRecord(item.meta.title);
      }
      this.$router.push(path);
    },
    toggleMenu() {
      if (this.isMenuCollapse) {
        this.$store.commit("siderExpand");
      } else {
        this.$store.commit("siderCollapse");
      }
    },
    getPermission(name) {
      if (this.user.roleType == 1) {
        return true;
      }
      let permissionArr = this.$store.state.permissions.filter(
        (item) => item.name == name
      );
      if (name == "screenPage") {
        return true;
      }
      if (permissionArr.length == 1) {
        return permissionArr[0];
      }
      return false;
    },
    getLeaf(item) {
      if (this.user.roleType == 1) {
        return !item.leaf;
      }
      let permissionId = 0;
      let permissions = this.$store.state.permissions.filter(
        (n) => n.name == item.name
      );
      if (permissions.length == 1) {
        permissionId = permissions[0].permissionId;
      }
      let result =
        this.$store.state.permissions.filter(
          (item) => item.parentId == permissionId && item.type == 1
        ).length > 0;
      return result;
    },
    logout: function () {
      this.$confirm(this.$l("确认退出吗?"), this.$l("退出系统"), {
        type: "warning",
      })
        .then(() => {
          this.$http
            .get(this.$apiConfig.user_logout_url, {
              params: {
                username: this.user.username,
                token: localStorage.getItem("token"),
              },
            })
            .then((response) => {
              this.$store.state.isStopAlarmTips = true;
              window.clearTimeout(this.$store.state.alarmTipsTimer);
              if (this.$store.state.notify) {
                this.$store.state.notify.close();
              }
              localStorage.clear();
              sessionStorage.clear();
              this.$router.push({ path: "/login" });
            })
            .catch((error) => {
              this.$sentry.captureException(error);
            });
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    newhref: function () {
      var href =
        "https://www.daantc.com:8443/cas/autoLogin?token=eyJhbGciOiJIUzI1NiJ9.eyJsb2dpblVzZXIiOiJjYW9saWFuZyIsImxvZ2luUHNzd29yZCI6IjEyMzQ1NiJ9.a6Udvx_NWwr8K5RvOt5jr94MI3ekk26wbjGiaL2kf30&service=https://www.daantc.com:8444/elevator-monitor/shiro-cas";
      window.open(href, "_blank");
    },
    openIndex() {
      if (this.$store.state.isShowMenu) {
        window.open("https://www.hitachi-helc.com", "_blank");
      }
      this.$store.state.isShowMenu = true;
      this.$router.push({ path: "/index" });
    },
    openOMS() {
      this.$router.push({ path: "/oms" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.pagesider {
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 999;
  height: 100%;
  // background: $--color-black;

  transition: all 0.2s ease;
  width: 310px !important;
  .logo {
    display: inline-block;
    // width: 300px;
    width: 100%;
    // height: 100%;
    height: 100px;
    padding-top: 8px;
    padding-left: 20px;
    padding-right: 60px;
    // background: $--color-black;
    display: flex;
    align-items: center;
    // background: url("../assets/img/dianxin.png") no-repeat center;
    .el-image {
      max-width: 250px;
      height: 90px;
      .el-image__inner {
        width: auto;
        max-width: 280px;
      }
    }
  }
  .el-button.toggle-btn {
    position: absolute;
    right: 20px;
    top: 32px;
    width: auto;
    margin: 0;
    z-index: 1;
    color: $--color-black;
    svg {
      width: 18px;
      height: 18px;
    }
  }

  h4 {
    font-size: 17px;
    padding: 0.5em 12px;
    margin-bottom: 10px;
    color: $--menu-item-font-color;
    border-bottom: 1px solid rgba(#000, 0.1);
    i {
      vertical-align: middle;
      display: inline-flex;
      width: 34px;
      height: 34px;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      border-radius: 10em;
      background: rgba(#fff, 0.8);
      .svg-icon {
        margin-right: 0;
      }
    }
  }
  &-c {
    flex: 1;
    // display: flex;
    // flex-direction: column;
    overflow-y: auto;
    // padding-bottom: 50px;
    .el-button {
      width: 9em;
      margin-top: 20px;
      margin-bottom: 50px;
    }
    @extend %scroll-dark;
  }
  .el-menu--collapse {
    width: 60px;
    // padding: 0 8px;
    padding: 0;
    h4 {
      overflow: hidden;
      height: 0;
      // width: 0;
      margin: 0px 20px 0;
      padding: 0;
    }
    ::v-deep .el-tooltip {
      text-align: center;
      padding: 0 8px !important;
    }
    .svg-icon {
      margin: auto;
    }
    ::v-deep .el-submenu__title,
    .el-menu-item {
      padding: 0 8px !important;
      margin-left: 4px;
      margin-right: 4px;
    }
  }
  &.is-collapsed {
    width: 60px !important;
    .logo {
      padding-left: 0;
      padding-right: 0;
    }
    .el-image {
      display: none;
    }
  }
}
.el-menu {
  border-right: 0;
  padding: 0 24px;
  .svg-icon {
    width: 18px;
    height: 18px;
    margin-right: 20px;
    ::v-deep [pid="0"],
    ::v-deep [pid="2"] {
      fill: $--color-text-primary;
    }
    ::v-deep [pid="1"] {
      fill: #7f8185;
    }
  }
  .is-active {
    .svg-icon {
      ::v-deep path {
        fill: #fff !important;
      }
      // fill: none;
      ::v-deep [pid="1"] {
        fill: $--color-primary !important;
        stroke: none;
      }
    }
    // .svg-all [pid="1"] {
    //   fill: $--color-primary;
    //   stroke: none;
    // }
    // .svg-run [pid="1"] {
    //   fill: $--color-primary;
    //   stroke: none;
    // }
    // .svg-shield [pid="1"] {
    //   fill: $--color-primary;
    //   stroke: none;
    // }
    // .svg-pie [pid="1"] {
    //   fill: $--color-primary;
    //   stroke: none;
    // }
    // .svg-screen [pid="1"] {
    //   fill: $--color-primary;
    //   stroke: none;
    // }
    // .svg-cog [pid="1"] {
    //   fill: $--color-primary;
    //   stroke: none;
    // }
  }
  // .el-menu-item,
  // .el-submenu__title {
  //   padding-left: $--base-padding !important;
  // }

  ::v-deep .el-submenu__title,
  .el-menu-item {
    border-radius: $--border-radius-base;
    overflow: hidden;
    height: 52px;
    line-height: 52px;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    span {
      max-width: 200px;
      overflow: hidden;
      display: inline-block;
      text-overflow: ellipsis;
    }
  }
  .el-submenu .el-menu-item {
    font-size: $--font-size-small;
    padding-left: ($--base-padding + 38) !important;
    height: 35px;
    line-height: 35px;
  }

  .el-menu-item.is-active,
  .el-submenu.is-active > ::v-deep .el-submenu__title {
    background: $--color-black;
    color: #fff;
  }

  .el-submenu.is-active .el-menu-item.is-active {
    // background: rgba($--color-black, 0.1);
    background: transparent;
    color: $--color-primary;
  }
}

::v-deep .pagesider-c .el-button {
  margin-bottom: 0px;
}

//----------------------------
//  自适应
//----------------------------
@media screen and (max-width: $--lg) {
  .pagesider {
    width: 250px !important;
  }
  .pagesider .logo .el-image .el-image__inner {
    max-width: 200px;
  }
}
</style>
<style lang="scss">
.el-menu--popup {
  background: $--background-color-base;
  background: url("~@/assets/img/bg.jpg") no-repeat center;
  background-size: cover;
  padding: 8px;
  .el-menu-item:hover {
    // background: rgba($--color-primary, 0.1);
  }
}
</style>
